import { Container, Typography } from "@mui/material";
import Layout from "../components/layout/LandingPageLayout";

const Refund = () => {
  return (
    <Layout>
      <Container sx={{ py: 6 }}>
        <Typography variant="h4" gutterBottom>
          Refund & Cancellation Policy
        </Typography>
        <Typography paragraph>
          Thank you for choosing F-AI. Please read our refund and cancellation
          policy carefully.
        </Typography>
        <Typography paragraph>
          - Payments once made are generally non-refundable. <br />
          - Refunds (if applicable) will be processed within 7–10 business days
          through the original payment method. <br />- For subscription
          services, cancellations can be requested by contacting our support
          team.
        </Typography>
      </Container>
    </Layout>
  );
};

export default Refund;
